
import {
  Box,
  Flex,
  HStack,
  IconButton,
  useDisclosure,
  useColorModeValue,
  Stack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Button,
  Image, Menu, MenuButton, MenuList, MenuItem
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon, ChevronDownIcon } from '@chakra-ui/icons';

import { useNavigate } from 'react-router-dom';


const Links = ['Live', 'Config', 'Geofence', 'Country', 'City', 'Subscription', 'Payment-Mode', 'Payment-History'];

const NavLink = ({ children, onClick }) => (
  <Button
    variant="ghost"
    _hover={{ bg: useColorModeValue('gray.200', 'gray.700') }}
    px={3}
    onClick={onClick}
  >
    {children}
  </Button>
);

const Navbar = () => {
  const navigate = useNavigate();

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (

    <Box position="fixed"
      top="0"
      left="0"
      right="0"
      zIndex="1000" bg={useColorModeValue('white', 'gray.800')} px={4} boxShadow='md'>
      <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
        <Image src="/assets/images/logo.png" alt="MyLogo" height="100px" />

        {/* Desktop Links */}
        <HStack spacing={8} alignItems={'center'} display={{ base: 'none', md: 'flex' }}>
          {Links.map((link) => (
            <NavLink
              key={link}
              onClick={() => navigate(`/admin/${link.toLowerCase()}`)}
            >
              {link}
            </NavLink>
          ))}

          <Menu>
            <MenuButton as={Button} rightIcon={<ChevronDownIcon />} variant="ghost">
              More
            </MenuButton>
            <MenuList>

              <MenuItem  onClick={() => navigate(`/admin/company`)}>
                Company
              </MenuItem>

              <MenuItem  onClick={() => navigate(`/admin/enquiry`)}>
                Enquiry
              </MenuItem>

            </MenuList>
          </Menu>

        </HStack>

        {/* Mobile Menu Button */}
        <IconButton
          size={'md'}
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          aria-label={'Open Menu'}
          display={{ md: 'none' }}
          onClick={isOpen ? onClose : onOpen}
        />
      </Flex>

      {/* Mobile Drawer */}
      <Drawer placement="right" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader borderBottomWidth="1px">Menu</DrawerHeader>
          <DrawerBody>
            <Stack spacing={4}>
              {Links.map((link) => (
                <NavLink key={link}>{link}</NavLink>
              ))}
            </Stack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  )
}

export default Navbar
